import React, { useCallback, useEffect, useState } from "react";

import NoticeService, { Notice } from "../../../services/NoticeService";
import NoticeDialog from "./NoticeDialog";

const storageKey = (notice: Notice) => `@PortalPGM:notice:${notice.id}:${notice.version}`;

export default function NoticeModal() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let mounted = true;

    NoticeService.current()
      .then((currentNotice) => {
        if (!mounted || !currentNotice) {
          return;
        }

        let dismissed = false;

        try {
          dismissed = Boolean(sessionStorage.getItem(storageKey(currentNotice)));
        } catch (error) {
          dismissed = false;
        }

        setNotice(currentNotice);
        setOpen(!dismissed);
      })
      .catch(() => undefined);

    return () => {
      mounted = false;
    };
  }, []);

  const handleClose = useCallback(() => {
    if (notice) {
      try {
        sessionStorage.setItem(storageKey(notice), "dismissed");
      } catch (error) {
      }
    }

    setOpen(false);
  }, [notice]);

  if (!notice) {
    return null;
  }

  return <NoticeDialog notice={notice} open={open} onClose={handleClose} />;
}
